import React from "react";

export default function Icon(props){
    return (
         <i className={props.class}></i>
    )
}